// ======================================================================
// File: RFQQuoteEntry.jsx
// Module: PPE → Procurement → RFQ
//
// Purpose:
// - Internal RFQ Quote Entry Screen
// - Open through PPE menu
// - Load RFQ detail
// - Vendor selected from URL
//
// Route:
// /ppe/procurement/rfq/quote/:rfqId/:vendorId
// ======================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  useParams
} from "react-router-dom";

import rfqService from "../services/rfqService";

import "../rfq-ui.css";

export default function RFQQuoteEntry() {

  const {
    rfqId,
    vendorId
  } = useParams();

  const [loading, setLoading] =
    useState(false);

  const [rfq, setRfq] =
    useState(null);

  // ==========================================================
  // LOAD RFQ
  // ==========================================================

  useEffect(() => {
    if (rfqId) {
      loadRFQ();
    }
  }, [rfqId]);

  const loadRFQ = async () => {

    try {

      setLoading(true);

      const res =
        await rfqService.getRFQById(
          rfqId
        );

      setRfq(
        res?.data?.data || null
      );

    } catch (err) {

      console.error(
        "Failed to load RFQ",
        err
      );

    } finally {

      setLoading(false);

    }
  };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div className="rfq-page">

      <div className="rfq-header-card">

        <h2>
          RFQ Quote Entry
        </h2>

        <p>
          Vendor quotation entry screen
        </p>

      </div>

      <div
        className="rfq-card"
        style={{
          padding: "20px"
        }}
      >

        <div>
          <strong>
            RFQ ID :
          </strong>{" "}
          {rfqId}
        </div>

        <div>
          <strong>
            Vendor ID :
          </strong>{" "}
          {vendorId}
        </div>

        <hr />

        {loading && (
          <div>
            Loading RFQ...
          </div>
        )}

        {!loading &&
          rfq && (
            <>

              <div
                style={{
                  marginBottom: "20px"
                }}
              >

                <div>
                  <strong>
                    RFQ No :
                  </strong>{" "}
                  {rfq.rfq_no}
                </div>

                <div>
                  <strong>
                    Status :
                  </strong>{" "}
                  {rfq.status_name}
                </div>

                <div>
                  <strong>
                    Total Lines :
                  </strong>{" "}
                  {rfq.lines?.length || 0}
                </div>

                <div>
                  <strong>
                    Total Vendors :
                  </strong>{" "}
                  {rfq.vendors?.length || 0}
                </div>

              </div>

              <div className="rfq-table-wrapper">

                <table className="rfq-table">

                  <thead>

                    <tr>
                      <th>#</th>
                      <th>Material</th>
                      <th>Qty</th>
                      <th>UOM</th>
                      <th>Required Date</th>
                    </tr>

                  </thead>

                  <tbody>

                    {rfq.lines?.length === 0 && (
                      <tr>
                        <td colSpan="5">
                          No materials available
                        </td>
                      </tr>
                    )}

                    {rfq.lines?.map(
                      (
                        line,
                        index
                      ) => (
                        <tr
                          key={line.id}
                        >
                          <td>
                            {index + 1}
                          </td>

                          <td>
                            {line.material_name ||
                              line.material_id}
                          </td>

                          <td>
                            {line.qty}
                          </td>

                          <td>
                            {line.uom}
                          </td>

                          <td>
                            {line.required_date ||
                              "-"}
                          </td>
                        </tr>
                      )
                    )}

                  </tbody>

                </table>

              </div>

            </>
          )}

      </div>

    </div>
  );
}